import { BehaviorSubject } from 'rxjs';
import { createEpicMiddleware, ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { combineEpics } from 'redux-observable';
import { getCartDetailsEpic } from './views/cart/cart.epic';
import { sharePremiumServiceEpic, getShareContentPremiumServiceEpic } from './views/premium-services/premium-services.epic';
import { getCurrentUserEpic, getCheckMobileNumber, postVerifyPassword, postSendLoginOtp, postVerifyLoginOtp, postUpdateUserPassword, postUserLogin, getPortfolioDetailsEpic } from './views/login/login.epic';
import { getAgentDetailsEpic, getUserProfileInfoEpic, getAgentCertificatesEpic, getAgentProfilePicEpic, getDiwaliPdfEpic, getCustomerCountEpic, getCustomerOrderDetailsEpic, getCalculatorLeadsCountEpic, postMergeCartsEpic, getFetchAgentVerificationEpic} from './views/user/user.epic';
import { postCreateLeadEpic } from './components/create-lead/create-lead.epic';
import { occupationDetailsEpic } from './views/investor-profile/occupation-Details/occupation-details.epic';
import { personalDetailsEpic } from './views/investor-profile/personal-details/personal-details.epic';
import { getCheckIfscEpic } from './views/investor-profile/bank-details/bank-details.epic';
import { checkKycStatusEpic } from './views/investor-profile/kyc-details/kyc-details.epic';
import { getProfileViewEpic } from './views/investor-profile/profile-view.epic';
import { getRiskProfileResultEpic } from 'views/investor-profile/risk-profile/risk-profile.epic';
import { getMandatesListEpic } from './views/mandates/mandate.epic';
import { getAllMintpacksEpic } from 'views/render-view/renderView.epic';

export const epic$ = new BehaviorSubject( combineEpics(
	getCurrentUserEpic,
	getCheckMobileNumber,
	postVerifyPassword,
	postSendLoginOtp,
	postVerifyLoginOtp,
	postUpdateUserPassword,
	postUserLogin,
	getAgentDetailsEpic,
	getCartDetailsEpic,
	sharePremiumServiceEpic,
	getShareContentPremiumServiceEpic,
	postCreateLeadEpic,
	occupationDetailsEpic,
	personalDetailsEpic,
	getCheckIfscEpic,
	checkKycStatusEpic,
	getProfileViewEpic,
	getPortfolioDetailsEpic,
	getRiskProfileResultEpic,
	getUserProfileInfoEpic,
	getMandatesListEpic,
	getAgentCertificatesEpic,
	getAgentProfilePicEpic,
	getDiwaliPdfEpic,
	getCustomerCountEpic,
	getAllMintpacksEpic,
	getCustomerOrderDetailsEpic,
	getCalculatorLeadsCountEpic,
	postMergeCartsEpic,
	getFetchAgentVerificationEpic
	// saveProfileViewEpic,
) );
export const dependencies = { getJSON: ajax.getJSON };

export const epicMiddleWare = createEpicMiddleware( { dependencies } );

export const rootEpic = ( action$, ...rest ) =>
	epic$.pipe(
		mergeMap( epic =>
			epic( action$, ...rest ).pipe(
				takeUntil( action$.pipe( ofType( 'EPIC_END' ) ) )
			)
		)
	);
